import React from 'react';
import { Plugin, CustomEditor } from '../types';

const ImagePlugin: Plugin = {
  name: 'image',
  
  commands: {
    insertImage: (editor: CustomEditor, url: string, alt?: string, caption?: string) => {
      // Create image element
      const imageElement = {
        type: 'image' as const,
        url,
        alt: alt || '',
        caption: caption || '',
        children: [{ text: '' }]
      };
      
      // Insert image at current selection
      const { insertNode } = editor;
      insertNode(imageElement);
    }
  },

  renderElement: (props) => {
    const { attributes, children, element } = props;
    
    if (element.type === 'image') {
      const { url, alt, caption } = element as any;
      return (
        <div {...attributes} style={{ textAlign: 'center', margin: '1em 0' }}>
          <div contentEditable={false}>
            <img
              src={url}
              alt={alt || ''}
              style={{
                maxWidth: '100%',
                height: 'auto',
                borderRadius: '4px',
                border: '1px solid #e5e7eb'
              }}
            />
            {caption && (
              <div style={{ 
                textAlign: 'center', 
                fontSize: '0.9em', 
                color: '#6b7280',
                marginTop: '8px',
                fontStyle: 'italic'
              }}>
                {caption}
              </div>
            )}
          </div>
          {children}
        </div>
      );
    }
    
    return undefined;
  }
};

export default ImagePlugin; 